<template>
<div>
    <div class="mcc-dialog-overlay">
        <dialog class="mcc-dialog mcc-dialog--info mcc-dialog--md" ref="aboutDialogRef" id="aboutInfo-dialog">
            <section>
                <div class="mcc-dialog__header">
                    <h2 class="h4">{{productName}}</h2>
                    <button type="button" class="mcc-button mcc-button--sm  mcc-button--ghost mcc-button--icon-only" @click="closeDialog">
                        <mcc-icon name="close" aria-hidden="true"></mcc-icon>
                        <span class="mcc-button__label">Button</span>
                    </button>
                </div>
                <div class="mcc-dialog__body">
                    <div class="mcc-row" v-show="fetchCall">
                        <div class="mcc-col colSpinner">
                            <div class="spinner-overlay">
                                <div class="spinner-background"></div>
                                <div class="spinner-flex">
                                    <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                                        <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                        <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="mcc-row" v-show="!fetchCall">
                        <div class="mcc-col">
                            <div id="aboutdataContainer">
                                <div v-for="(obj, index) in aboutInfo" :key="index" class="infoItem">
                                    <div class="mcc-col-6">
                                        <span>{{obj.key}}</span>
                                    </div>
                                    <div class="mcc-col-6" v-if="obj.key=='User roles'">
                                        <span style="word-wrap: break-word;" v-html="obj.value"></span>
                                    </div>
                                    <div class="mcc-col-6" v-else-if="obj.key=='Product / Build'">
                                        <span v-html="obj.value"></span>
                                    </div>
                                    <div class="mcc-col-6" v-else>
                                        <span>{{obj.value}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="mcc-dialog__footer">
                    <div class="mcc-button-group mcc-button-group--spaced">
                        <button type="submit" class="mcc-button mcc-button--info" @click="closeDialog">Ok</button>
                    </div>
                </div>
            </section>
        </dialog>
    </div>
</div>
</template>

<script>
import AboutAPI from "../../services/AboutAPI";
import moment from 'moment';

export default {
    name: "About",
    data() {
        return {
            aboutInfo: [],
            actuatorBuildInfo: '',
            gitCommitNumber: '',
            productName: '',
            fetchCall: false,
        }
    },
    methods: {
        closeDialog() {
            this.$refs.aboutDialogRef.close();
        },
        aboutDialogShowHandler() {
            let self = this;
            self.fetchCall = true;
            this.$refs.aboutDialogRef.show()
            self.initAboutInfo();
        },
        initAboutInfo() {
            let self = this;
            AboutAPI.getActuatorInfo().then(data => {
                if (data != null) {
                    if (data.build != null) {
                        self.actuatorBuildInfo = data.build.name + " " + data.build.version + "-" + data.build.number;
                    }
                    if (data.git != null) {
                        self.gitCommitNumber = data.git.commit.id.full;
                    }
                }
            });

            AboutAPI.getThemeInfo().then(data => {
                if (data != null) {
                    self.productName = data.productName;
                }
            });

            AboutAPI.getAboutData().then(data => {
                if (data != null) {
                    self.fetchCall = false;

                    if (data.expiryDate != "") {
                        data.expiryDate = moment(data.expiryDate, 'YYYY-MM-DD').format('DD/MM/YYYY');
                    }
                    let userRoleHTMl = "";
                    let popoverContent = "<div class='mcc-popover__content'>";
                    let totalInPopover = 0;
                    let isMoreThan5 = false;
                    if (data.userRole) {
                        let userRoles = data.userRole.split(",");
                        userRoles.forEach((element, index) => {
                            if (index >= 5) {
                                isMoreThan5 = true;
                                totalInPopover++;
                                popoverContent += "<span class='mcc-chip mcc-chip--soft-primary userRoleChip mcc-chip--sm'>" + element + "</span>";
                            } else {
                                userRoleHTMl += "<span class='mcc-chip mcc-chip--soft-primary userRoleChip mcc-chip--sm'>" + element + "</span>";
                            }
                        });
                        popoverContent += "</div>";
                        let popoverChipComp = "<details class='mcc-popover mcc-popover--bottom-start'><summary class='mcc-chip mcc-chip--soft-primary userRoleChip mcc-chip--sm'><span class='mcc-chip__label mu-d-flex'>" + totalInPopover + ' more' + "<mcc-icon class='mcc-icon--primary mu-ml-01' name='angle_down' icon-set='' width='24' height='24'></mcc-icon>" + "</span></summary>" + popoverContent + "</details>";
                        if (isMoreThan5) {
                            userRoleHTMl += popoverChipComp;
                        }
                    }
                    self.aboutInfo = [{
                            "key": "Username",
                            "value": data.userName
                        },
                        {
                            "key": "User full name",
                            "value": data.firstName + " " + data.lastName
                        },
                        {
                            "key": "User roles",
                            "value": userRoleHTMl
                        },
                        {
                            "key": "Product / Build",
                            "value": (self.actuatorBuildInfo ? self.actuatorBuildInfo + "<br/>" : "") + "BPM Modeller " + process.env.VUE_APP_MODELLER_VERSION + "<br/>" + "BPM Form designer " + process.env.VUE_APP_FORMDESIGNER_VERSION
                        },
                        {
                            "key": "Licence number",
                            "value": data.licenseKey
                        },

                        {
                            "key": "Licensed applications",
                            "value": data.appsAllowed
                        },
                        {
                            "key": "Licence expiry",
                            "value": data.expiryDate
                        },
                        {
                            "key": "Git information",
                            "value": self.gitCommitNumber
                        },
                        {
                            "key": "Selected Worksplace",
                            "value": self.$store.getters.getSelectedWorksPlace
                        },
                    ];
                }
            });

        }
    }
}
</script>

<style>
.infoItem {
    border-bottom: 1px solid #e0e0e7;
    display: flex;
    justify-content: space-between;
    padding: 10px !important;
}

.infoItem:last-child {
    border-bottom: unset !important
}

#copyright span {
    line-height: 2.5;
}

#copyright {
    display: flex;
    justify-content: center;
    padding-top: 10px;
}

.userRoleChip {
    margin: 3px !important;
}
</style>
